import React, { useState } from 'react';
import ScheduleList from './schedules/ScheduleList';
import TabBody from 'components/tab-components/TabBody';
import TabHeader from 'components/tab-components/TabHeader';
import TabLayout from 'components/tab-components/TabLayout';
import TaskList from './tasks/TaskList';
import { tasksTabsList } from './utils';
import ArchivedScheduleList from './archived/ArchivedScheduleList';
import ArchivedTaskList from './archived/ArchivedTaskList';

const Tasks = () => {
  const [selectedTab, setSelectedTab] = useState(tasksTabsList[0]);

  return (
    <TabLayout>
      <TabHeader
        tabList={tasksTabsList}
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
      />
      <TabBody>
        <div className='p-3'>
          {selectedTab.value === 'scheduled_task' ? (
            <ScheduleList />
          ) : selectedTab.value === 'active_task' ? (
            <TaskList />
          ) : selectedTab.value === 'archived_schedule' ? (
            <ArchivedScheduleList />
          ) : selectedTab.value === 'archived_task' ? (
            <ArchivedTaskList />
          ) : (
            <></>
          )}
        </div>
      </TabBody>
    </TabLayout>
  );
};

export default Tasks;
